import { URLS } from '@/config'
import { FP_APPLICATIONS } from '@/dashboards/common/urls'

const env = URLS.URL_ENV_CODE
const URL_ENV_CODE = env
const GATEWAY_BASE_URL = `https://proxy${env}.farmapolis.es/v1`
const LOGIN_URL = GATEWAY_BASE_URL + '/auth/user/login'
const LOGOUT_URL = '/logout'
const TOKEN_URL = ''
const CHECK_SESSION_URL = '/toctoc'
const SHELL_CONFIG_URL = process.env.VUE_APP_SHELL_CONFIG_URL || `https://public-storage.farmapolis.es/micro-frontends/shell-config/hub-${URLS.TAG_ENV_CODE}.json?t=${Date.now()}`

export default {
  FP_APPLICATIONS,
  URL_ENV_CODE,
  GATEWAY_BASE_URL,
  LOGIN_URL,
  LOGOUT_URL,
  TOKEN_URL,
  SHELL_CONFIG_URL,
  CHECK_SESSION_URL
}
